import React, {useState} from "react";

export default function CareerMatchesPopup(props) {

    const [collection, setCollection] = useState(props.career_matches.slice(0,20));
    const [page, setPage] = useState(1);
    const totalPages = Math.ceil(props.career_matches.length/20);
    const [sortBy, setSortBy] = useState("score_desc");

    const firstPage = page <= 3 ? 1 : page >= (totalPages - 2)  ? totalPages - 4 : page - 2;


    const goToPage = (e, p) => {
      e.preventDefault();
      let newCollection = getCollection(sortBy, p);
      setPage(p);
      setCollection(newCollection);
    };

    const getCollection = (sort,page) => {
        let [field, type] = sort.split('_');
        let newCollection = [...props.career_matches];
        if (field === 'name') {
            newCollection = newCollection.sort((a,b) => (a.career.name > b.career.name ) ? 1 : ((b.career.name  > a.career.name ) ? -1 : 0))
        } else  {
            newCollection =  newCollection.sort((career) => career.score)
        }
        if (type === 'asc') {
            newCollection = newCollection.reverse()
        }
        let collectionPage = page - 1;
        newCollection = newCollection.slice(collectionPage*20,collectionPage*20+20);
        return newCollection;
    };

    const sort = (sort) => {
        let newCollection =  getCollection(sort, 1);
        setSortBy(sort);
        setPage(1);
        setCollection(newCollection);
    };


    return (
           <React.Fragment>
                <div className="grid-x user__title">
                    <div className="small-12 cell">
                        <h3>Career Matches</h3>
                        <a className="popup__close">&times;</a>
                    </div>
                </div>
                <div className="grid-x">
                    <div className="small-12 cell">
                        <div className="user__table user__table--view">
                            <table>
                                <thead>
                                <tr>
                                    <th><p className="primary" onClick={() => sort(sortBy === 'name_desc' ? 'name_asc' : 'name_desc')}>Profession<span
                                        className={`small-icon green-chevron-down ${sortBy === 'name_asc' ? 'rotated' : ''}`}/></p></th>
                                    <th><p className="primary" onClick={() => sort(sortBy === 'score_desc' ? 'score_asc' : 'score_desc')}>Match<span
                                        className={`small-icon green-chevron-down ${sortBy === 'score_asc' ? 'rotated' : ''}`}/></p></th>
                                    <th><p className="primary">Ann. Salary</p></th>
                                    <th><p className="primary">Education</p></th>
                                    <th><p className="primary">Ann. Growth</p></th>
                                    <th colSpan="2"/>
                                </tr>
                                </thead>
                                <tbody>
                                {collection.map((career) => {
                                    return (
                                        <tr key={career.career.id}>
                                            <td><p className="primary">{career.career.name}</p></td>
                                            <td className="col-right padR20"><p className="primary">{career.score}%</p></td>
                                            <td className="col-right"><p className="blue">{props.displaySalary(career.career.salary_mid)}</p></td>
                                            <td><p className="blue">{props.displayEducation(career.career.education_level, career.career.study_time)}</p></td>
                                            <td className="col-right"><p className="blue">{career.career.projected_growth}</p></td>
                                            <td className="view"><p><a href={`/careers/${career.career.path}`} target={'_blank'} className="blue-off-link">View</a></p></td>
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>
                        </div>
                        <div className="grid-x flex-center">
                            <nav aria-label="pagination">
                                <ul className="pagination pagination--grey text-center">
                                    {page > 1 ? <li onClick={(e) => goToPage(e,page-1) }  className="pagination-previous"><a/></li> : null}
                                    {[firstPage,firstPage+1, firstPage+2,firstPage+3,firstPage+4].map((p) => {
                                        return (
                                           <li key={p} onClick={(e) => goToPage(e,p) } className={p === page ? "current" : ''}>
                                               <a href={"#"+p}>{p}</a>
                                           </li>
                                        )
                                    })}
                                    {page < totalPages ? <li onClick={(e) => goToPage(e,page+1) }  className="pagination-next"><a/></li> : null}
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
           </React.Fragment>
    )

}